import {useLocalStorageState} from 'hooks/useLocalStorageState'
import React, {useContext} from 'react'
import {Ventrata} from 'types'

type Props = {
  children: React.ReactNode
}

type Result = {
  order: Ventrata.Order
  error?: any
}

type ResultValue = {
  result: Result | null
  setResult: (result: Result | null) => Result | null
}

export const ResultContext = React.createContext<ResultValue>({
  result: null,
  setResult: () => null,
})

const validator = (data: unknown) => data === null || typeof data === 'object'

export const ResultProvider = ({children}: Props) => {
  const [result, setResult] = useLocalStorageState<Result | null>({
    defaultValue: null,
    entity: 'result',
    validator,
  })

  const value = {
    result,
    setResult,
  }

  return <ResultContext.Provider value={value}>{children}</ResultContext.Provider>
}

export const useOptionalResult = () => {
  const {result} = useContext(ResultContext)
  return result
}

export const useResultSetter = () => {
  const {setResult} = useContext(ResultContext)
  return setResult
}
